export const formatPath = (contractPath: string) => {
	return contractPath.replace(/\\/g, '/')
}
